
export default {
    namespaced: true,
    pages: {
      title: "pagina web | páginas da web",
      description: "descrição",
      url: "URL",
      facilities: "Instalações",
      shared: "compartilhado",
    },
  }
